import { LineChartConfig } from "..";
import DateHelper from "@/utils/helpers/DateHelper";

class AvgRollTimeChartConfig extends LineChartConfig {
    constructor(current, prev, nat) {
        super(current, prev, nat);

        this.options.scales.yAxes.push({
            ticks: {
                beginAtZero: true,
                // max: 3600 * 7,
                // stepSize: 3600,
                callback: (value) => {
                    return DateHelper.getTimeFromSeconds(value)
                }
                
                
            },
            gridLines:{
                drawOnChartArea: true
            }
        });

        this.options.scales.xAxes.push({
            offset: true,
            gridLines:{
                drawOnChartArea: true
            },
            ticks: {
                callback: function(value, index, values) {
                    return value;
                }
            }
        });

        this.options.legend = {
            display: false
            
        }
    }

    
}

export {
    AvgRollTimeChartConfig
}